import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { type FC, useState } from "react";
import { useApiCall } from "../api/api";
import type { Exam, ExamParticipant } from "../api/dto";
import { ModalFooter } from "../components/layout/ModalProvider";
import {
  firstFreePosition,
  isParticipantFormValid,
  ParticipantForm,
  type ParticipantFormValues,
  participantFormPayload,
  participantFormValues,
} from "../components/participants/ParticipantForm";
import { useRefresh } from "../components/RefreshController";

export const AddParticipantModal: FC<{ exam: Exam; participants: ExamParticipant[] }> = (props) => {
  const { addParticipant } = useApiCall();
  const refresh = useRefresh();
  const [values, setValues] = useState<ParticipantFormValues>(() =>
    participantFormValues(undefined, firstFreePosition(props.participants)),
  );

  const save = async () => {
    await addParticipant(props.exam.id, participantFormPayload(values));
    refresh();
  };

  return (
    <div>
      <ParticipantForm
        exam={props.exam}
        participants={props.participants}
        values={values}
        onChange={setValues}
      />
      <ModalFooter
        text={"Deelnemer toevoegen"}
        icon={faPlus}
        disabled={!isParticipantFormValid(values)}
        onSubmit={save}
      />
    </div>
  );
};
